import { HttpClient } from '@angular/common/http';
import { ActionUserManagementApi } from './action-user-management/api.action-user-management';
import { ActivityLogApi } from './activity-log/api.activity-log';
import { AdvertisingApi } from './advertising/api.advertising';
import { ApiClientConfig } from './api-client.config';
import { AuthApi } from './auth/api.auth';
import { BillingApi } from './billing/api.billing';
import { ChatApi } from './chat/api.chat';
import { CoinManagementApi } from './coin-management/api.coin-management';
import { CommentsApi } from './comments/api.comments';
import { FanpageManagementApi } from './fanpage-management/api.fanpage-management';
import { PageApi } from './fanpage/api.fanpage';
import { FeeApi } from './fee/api.fee';
import { FollowerApi } from './follower/api.follower';
import { FriendApi } from './friend/api.friend';
import { GroupManagementApi } from './group-management/api.group-management';
import { GroupApi } from './group/api.group';
import { LimitFeatureApi } from './litmit-feature/api.litmit-feature';
import { MediaApi } from './media/api.media';
import { PostApi } from './post/api.post';
import { ReactionsApi } from './reactions/api.reactions';
import { ReportApi } from './report/api.report';
import { SocialGiftApi } from './social-gift/api.social-gift';
import { StatisticsApi } from './statistics/api.statistics';
import { StorageApi } from './storage/api.storage';
import { UserProfileApi } from './user-profile/api.user-profile';
import { UserApi } from './user/api.user';
import { UsersSentCoinApi } from './users-sent-coin/api.users-sent-coin';
export class ApiClient {
  readonly auth: AuthApi;
  readonly activityLog: ActivityLogApi;
  readonly actionUserManagement: ActionUserManagementApi;
  readonly billing: BillingApi;
  readonly coinManagement: CoinManagementApi;
  readonly group: GroupApi;
  readonly limitFeature: LimitFeatureApi;
  readonly post: PostApi;
  readonly reactions: ReactionsApi;
  readonly comments: CommentsApi;
  readonly userProfile: UserProfileApi;
  readonly user: UserApi;
  readonly media: MediaApi;
  readonly usersSentCoin: UsersSentCoinApi;
  readonly storage: StorageApi;
  readonly friend: FriendApi;
  readonly page: PageApi;
  readonly fee: FeeApi;
  readonly groupManagement: GroupManagementApi;
  readonly fanpageManagement: FanpageManagementApi;
  readonly report: ReportApi;
  readonly statistics: StatisticsApi;
  readonly advertising: AdvertisingApi;
  readonly follower: FollowerApi;
  readonly socialGift: SocialGiftApi;
  readonly chat: ChatApi;
  constructor(
    private http: HttpClient,
    config: ApiClientConfig
  ) {
    this.auth = new AuthApi(this.http, config);
    this.activityLog = new ActivityLogApi(this.http);
    this.actionUserManagement = new ActionUserManagementApi(this.http);
    this.billing = new BillingApi(this.http, config);
    this.coinManagement = new CoinManagementApi(this.http);
    this.group = new GroupApi(this.http, config);
    this.limitFeature = new LimitFeatureApi(this.http);
    this.post = new PostApi(this.http, config);
    this.reactions = new ReactionsApi(this.http, config);
    this.comments = new CommentsApi(this.http, config);
    this.userProfile = new UserProfileApi(this.http, config);
    this.user = new UserApi(this.http, config);
    this.media = new MediaApi(this.http, config);
    this.usersSentCoin = new UsersSentCoinApi(this.http, config);
    this.storage = new StorageApi(this.http, config);
    this.friend = new FriendApi(this.http, config);
    this.page = new PageApi(this.http, config);
    this.fee = new FeeApi(this.http, config);
    this.groupManagement = new GroupManagementApi(this.http);
    this.fanpageManagement = new FanpageManagementApi(this.http);
    this.report = new ReportApi(this.http, config);
    this.statistics = new StatisticsApi(this.http, config);
    this.advertising = new AdvertisingApi(this.http, config);
    this.follower = new FollowerApi(this.http, config);
    this.socialGift = new SocialGiftApi(this.http, config);
    this.chat = new ChatApi(this.http, config);
  }
}
